import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, margin: '20px', maxWidth: '800px' }}>
      <h1>Privacy Policy for Dabbavala (India)</h1>
      <p><em>Last Updated: March 26, 2025</em></p>
      <p>
        This Privacy Policy explains how Dabbavala (“we,” “us,” or “our”) collects, uses, discloses, and protects your
        personal information when you use our tiffin service in India. We comply with the applicable Indian data
        protection laws, including the Information Technology Act, 2000, and the Information Technology (Reasonable
        Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 (“IT Rules”).
      </p>
      <p>
        By using our services, you agree to the collection, use, and disclosure of information in accordance with this
        policy and the applicable laws of India.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>Personal Information:</h3>
      <p>
        When you place an order or inquire about our service, we may collect personal details such as your name, contact
        number, email address, and delivery address.
      </p>

      <h3>Transactional Information:</h3>
      <p>
        We collect details related to your orders, including order history, payment information, and delivery preferences.
        This data helps us manage orders and ensure timely delivery.
      </p>

      <h3>Usage Information:</h3>
      <p>
        If you visit our website or use our digital platforms, we may automatically collect information such as your IP
        address, browser type, device information, and browsing patterns. This data is used to improve our online services
        and user experience.
      </p>

      <h2>2. How We Use Your Information</h2>

      <h3>Order Fulfillment:</h3>
      <p>
        We use your personal and transactional data to process and deliver your tiffin orders efficiently. We only serve
        vegetarian meals from our verified facility located in Bilaspur, Chhattisgarh, India.
      </p>

      <h3>Service Improvement:</h3>
      <p>
        Information about how you interact with our website or service may be used to analyze and enhance our offerings.
      </p>

      <h3>Communication:</h3>
      <p>
        Your contact details may be used to notify you about order updates, promotional offers, or service changes. We will
        only send communications relevant to your use of our services. You can opt out of promotional communications at any
        time (see Section 6).
      </p>

      <h3>Compliance and Safety:</h3>
      <p>
        We may use your data to comply with legal obligations or to protect the rights, property, or safety of our users or
        others, in accordance with Indian law.
      </p>

      <h2>3. Sharing and Disclosure of Information</h2>

      <h3>Third-Party Service Providers:</h3>
      <p>
        We may share your information with trusted third-party vendors who assist us in operating our business (e.g.,
        payment processing, order delivery). These vendors are obligated to keep your information confidential and are not
        permitted to use it for any other purpose.
      </p>

      <h3>Legal Requirements:</h3>
      <p>
        Your personal data may be disclosed if required by law or if we believe such action is necessary to:
        <ul>
          <li>Comply with a legal obligation under Indian law;</li>
          <li>Protect and defend our rights or property;</li>
          <li>Prevent or investigate possible wrongdoing in connection with our services;</li>
          <li>Protect the personal safety of users or the public;</li>
          <li>Comply with orders from governmental or regulatory authorities.</li>
        </ul>
      </p>

      <h3>Business Transfers:</h3>
      <p>
        In the event of a merger, acquisition, or sale of all or part of our business, your information may be transferred
        as part of the transaction. In such cases, we will ensure that your data remains protected and continues to be
        handled in accordance with this Privacy Policy.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate physical, technical, and administrative measures to safeguard your personal information
        against unauthorized access, alteration, disclosure, or destruction. Our verified facility in Bilaspur adheres to
        strict security protocols to ensure the confidentiality and integrity of your data, in line with the IT Act, 2000
        and IT Rules, 2011.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your personal information for as long as necessary to fulfill the purposes for which it was collected,
        to comply with Indian legal obligations, resolve disputes, and enforce our agreements. Once your data is no longer
        needed, we will securely dispose of it in accordance with applicable Indian laws.
      </p>

      <h2>6. Your Rights and Choices</h2>

      <h3>Access and Correction:</h3>
      <p>
        You have the right to access, review, and request correction of the personal information we hold about you. You can
        do so by contacting us at the email address provided in Section 9.
      </p>

      <h3>Opt-Out:</h3>
      <p>
        If you prefer not to receive promotional communications from us, you may opt out by following the instructions
        provided in our emails or by contacting us directly. We will process your request in accordance with Indian law.
      </p>

      <h3>Data Deletion:</h3>
      <p>
        You may request that we delete your personal data, subject to any legal or regulatory requirements that necessitate
        retaining certain information. We will make reasonable efforts to comply with such requests under applicable
        Indian laws.
      </p>

      <h2>7. Children’s Privacy</h2>
      <p>
        Our services are not directed to children under the age of 18. We do not knowingly collect personal information
        from minors. If you become aware that a minor has provided us with personal information, please contact us
        immediately so that we can take appropriate steps to remove the information.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on our website with an updated
        effective date. We encourage you to review this page periodically to stay informed about our practices regarding
        your personal information and your rights under Indian law.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please
        contact us at:
      </p>
      <address>
        <strong>Dabbavala</strong><br />
        Verified Facility,<br />
        Bilaspur, Chhattisgarh, India<br />
        Email: <a href="mailto:dabbawala@gmail.com">dabbawala@gmail.com</a><br />
        {/* Phone: <a href="tel:your-contact-number">your-contact-number</a> */}
      </address>
      <p>
        By using our tiffin services, you consent to the practices described in this Privacy Policy and the applicable
        laws of India. We are committed to protecting your privacy and providing a secure, reliable service.
      </p>
      <p>
        If you require any further information or clarification, please do not hesitate to get in touch.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
